<div class="animate-pulse">
	<div class="mb-2 h-96 w-full rounded bg-gray-200"></div>
</div>
